import { DeanteData } from "../Universal/API/Context-API/AppProvider";
import { chars_to_show } from "./constants";

type CharsConfig = (typeof chars_to_show)[number];

export interface UnitFullRowData {
  chars: CharsConfig;
  index: number;
  resString: string;
  isOstatki: boolean;
  isNameField: boolean;
  key: string;
}

export interface UnitFullLayoutMetrics {
  centerWidth: string;
  canUseWideLayout: boolean;
  desktopContentWidth: number;
  mediaColumnWidth: number | null;
  detailsColumnWidth: number | null;
  imageWidth: number;
}

const isNameField = (chars: CharsConfig) =>
  chars.key === "name" || (Array.isArray(chars.key) && chars.key.includes("name"));

const hasOstatki = (unit: DeanteData) => {
  const ostatki = (unit as any).ostatki;
  const ostatkiPoland = (unit as any).ostatkiPoland;
  if (!ostatki && !ostatkiPoland) return false;

  const toNum = (value: unknown) => parseFloat(String(value ?? 0)) || 0;

  const total =
    toNum(ostatki?.FreeSklad) +
    toNum(ostatki?.ReservSklad) +
    toNum(ostatki?.VPutiFree) +
    toNum(ostatki?.VPutiReserv) +
    toNum(ostatki?.FreeSkladMSK) +
    toNum(ostatki?.ReservSkladMSK) +
    toNum(ostatki?.VPutiFreeMSK) +
    toNum(ostatki?.VPutiReservMSK) +
    toNum(ostatkiPoland?.stock);

  return total > 0;
};

const resolveRowValue = (unit: DeanteData, chars: CharsConfig) => {
  const unitAny = unit as any;

  let result = Array.isArray(chars.key)
    ? chars.key
        .map((key) => unitAny[key] ?? "")
        .filter((value: unknown) => value !== "")
        .join(", ")
    : unitAny[chars.key];

  if (chars.key === "rect") {
    result = String(result) === "1" ? "Есть" : "Отстуствует";
  }

  return result ?? "";
};

export const buildUnitFullRows = (unit: DeanteData): UnitFullRowData[] => {
  const showOstatki = hasOstatki(unit);

  return chars_to_show
    .map((chars, index) => {
      const nameField = isNameField(chars);
      if (nameField) return null;
      if (chars.key === "ostatki" && !showOstatki) return null;

      return {
        chars,
        index,
        resString: resolveRowValue(unit, chars),
        isOstatki: chars.key === "ostatki",
        isNameField: nameField,
        key: `${String(chars.label)}_${index}`,
      };
    })
    .filter(Boolean) as UnitFullRowData[];
};

export const getUnitFullLayoutMetrics = ({
  currentWidth,
  isSmallVersion,
  isMediumVersion,
  scaleAll,
}: {
  currentWidth: number;
  isSmallVersion: boolean;
  isMediumVersion: boolean;
  scaleAll: number;
}): UnitFullLayoutMetrics => {
  const centerWidth = isSmallVersion ? "90%" : isMediumVersion ? "80%" : "60%";
  const canUseWideLayout = !isSmallVersion && currentWidth >= 1180;
  const desktopContentWidth = Math.min(currentWidth - 40, 1560 * scaleAll);
  const mediaColumnWidth = canUseWideLayout
    ? Math.min(860 * scaleAll, desktopContentWidth * 0.62)
    : null;
  const detailsColumnWidth = canUseWideLayout
    ? Math.min(560 * scaleAll, desktopContentWidth * 0.34)
    : null;
  const imageWidth = Math.min(currentWidth - 40, 1000 * scaleAll);

  return {
    centerWidth,
    canUseWideLayout,
    desktopContentWidth,
    mediaColumnWidth,
    detailsColumnWidth,
    imageWidth,
  };
};
